/** Browser auth persistence helpers for Admin / IB / Client. */

export type AuthPersistMode = 'session' | 'local'

export function getAuthItem(key: string): string | null {
  try {
    return sessionStorage.getItem(key) ?? localStorage.getItem(key)
  } catch {
    return null
  }
}

/** Prefer the store that currently holds the token (session wins if both). */
export function detectAuthPersist(tokenKey: string): AuthPersistMode {
  try {
    if (sessionStorage.getItem(tokenKey) != null) return 'session'
    if (localStorage.getItem(tokenKey) != null) return 'local'
  } catch {
    /* ignore */
  }
  return 'session'
}

export function setAuthItem(key: string, value: string, mode: AuthPersistMode) {
  try {
    if (mode === 'local') {
      sessionStorage.removeItem(key)
      localStorage.setItem(key, value)
    } else {
      localStorage.removeItem(key)
      sessionStorage.setItem(key, value)
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearAuthItem(key: string) {
  try {
    sessionStorage.removeItem(key)
    localStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

export function persistAuthSession(opts: {
  tokenKey: string
  userKey: string
  token: string
  userJson?: string | null
  rememberMe: boolean
}) {
  const mode: AuthPersistMode = opts.rememberMe ? 'local' : 'session'
  setAuthItem(opts.tokenKey, opts.token, mode)
  if (opts.userJson) setAuthItem(opts.userKey, opts.userJson, mode)
  else clearAuthItem(opts.userKey)
}

export function clearAuthSession(tokenKey: string, userKey: string) {
  clearAuthItem(tokenKey)
  clearAuthItem(userKey)
}
